"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setLocale = exports.parseLocalDateString = exports.getWeekData = exports.formatText = exports.formatDateString = exports.formatDate = exports.Localization = void 0;
var import_locale_1 = require("./import-locale");
var locale_data_1 = require("./locale-data");
var parse_date_1 = require("./parse-date");
var globalizeOptionKeys = ['skeleton', 'date', 'time', 'datetime', 'raw', 'timezone'];
var Localization = /** @class */ (function () {
    function Localization(locale) {
        this.locale = 'en_US';
        this.formatDate = this.formatDate.bind(this);
        this.formatDateString = this.formatDateString.bind(this);
        this.formatText = this.formatText.bind(this);
        this.getWeekData = this.getWeekData.bind(this);
        this.parseLocalDateString = this.parseLocalDateString.bind(this);
        this.setLocale = this.setLocale.bind(this);
        if (typeof locale === 'string' && locale.length > 0) {
            this.locale = locale;
        }
    }
    Localization.prototype.ensureInitialized = function () {
        if (!this.globalize) {
            this.setLocale(this.locale);
        }
    };
    Localization.prototype.setLocale = function (locale) {
        var locImport = (0, import_locale_1.importLocale)(locale);
        this.locale = locImport.current;
        this.globalize = locImport.globalize;
        return {
            current: this.locale,
            globalize: this.globalize
        };
    };
    Localization.prototype.formatDate = function (date, options) {
        var e_1, _a;
        if (options === void 0) { options = {}; }
        this.ensureInitialized();
        var globalizeOptions = {};
        try {
            for (var _b = __values(Object.entries(options)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var _d = __read(_c.value, 2), key = _d[0], val = _d[1];
                if (globalizeOptionKeys.includes(key)) {
                    globalizeOptions[key] = val;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        try {
            return this.globalize(this.locale).formatDate(date, globalizeOptions);
        }
        catch (error) {
            return '';
            // TODO: need to add logging for both client and server, throwing an error here can break the entire app
            // throw Error(`Failed to format ${date} for ${current}: ${e.message}`);
        }
    };
    Localization.prototype.parseLocalDateString = function (dateString, options) {
        var e_2, _a;
        if (options === void 0) { options = {}; }
        this.ensureInitialized();
        var globalizeOptions = {};
        try {
            for (var _b = __values(Object.entries(options)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var _d = __read(_c.value, 2), key = _d[0], val = _d[1];
                if (globalizeOptionKeys.includes(key)) {
                    globalizeOptions[key] = val;
                }
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_2) throw e_2.error; }
        }
        try {
            return this.globalize(this.locale).parseDate(dateString, globalizeOptions);
        }
        catch (error) {
            throw Error("Failed to parse ".concat(dateString, " for ").concat(this.locale, ": ").concat(error.message));
        }
    };
    Localization.prototype.formatDateString = function (dateString, options) {
        if (options === void 0) { options = {}; }
        if ((typeof dateString === 'string' && dateString.length > 0) || dateString instanceof Date) {
            var date = dateString instanceof Date ? dateString : (0, parse_date_1.parseDate)(dateString);
            return this.formatDate(date, options);
        }
        return '';
    };
    Localization.prototype.formatText = function (key) {
        var _a;
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        this.ensureInitialized();
        try {
            return (_a = this.globalize(this.locale)).formatMessage.apply(_a, __spreadArray([key], __read(args), false));
        }
        catch (error) {
            return '';
            // TODO: need to add logging for both client and server, throwing an error here can break the entire app
            // throw Error(`Failed to localize ${key} for ${current}: ${e.message}`);
        }
    };
    Localization.prototype.getWeekData = function () {
        var country = (0, locale_data_1.getCountryCode)(this.locale);
        return {
            firstDay: locale_data_1.weekData.firstDay[country] || locale_data_1.weekData.firstDay['001']
        };
    };
    return Localization;
}());
exports.Localization = Localization;
var singleton = new Localization('en_US');
/**
 * @deprecated Do not use this function. Use l10n object instead.
 */
exports.formatDate = singleton.formatDate.bind(singleton);
/**
 * @deprecated Do not use this function. Use l10n object instead.
 */
exports.formatDateString = singleton.formatDateString.bind(singleton);
/**
 * @deprecated Do not use this function. Use l10n object instead.
 */
exports.formatText = singleton.formatText.bind(singleton);
/**
 * @deprecated Do not use this function. Use l10n object instead.
 */
exports.getWeekData = singleton.getWeekData.bind(singleton);
/**
 * @deprecated Do not use this function. Use l10n object instead.
 */
exports.parseLocalDateString = singleton.parseLocalDateString.bind(singleton);
/**
 * @deprecated Do not use this function. Use l10n object instead.
 */
exports.setLocale = singleton.setLocale.bind(singleton);
//# sourceMappingURL=localization.js.map